import styled, { css, keyframes } from 'styled-components'

/* Menus da barra do topo (conta e notificações), no mesmo visual da barra lateral. */

export const font = "'Plus Jakarta Sans', 'Poppins', sans-serif"

export const color = {
  text: '#18181b',
  soft: '#3f3f46',
  muted: '#71717a',
  faint: '#a1a1aa',
  line: '#ececf0',
  hover: '#f4f4f5',
  active: '#ededf0',
  accent: '#1f63e3',
  danger: '#dc2626',
}

const pop = keyframes`
  from { opacity: 0; transform: translateY(-4px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 4px 4px 4px 10px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover,
  &[aria-expanded='true'] {
    background: rgba(255, 255, 255, 0.14);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 1px;
  }

  .ps-profile-text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 0;

    h1,
    h2,
    h3,
    div,
    span {
      margin-right: 0 !important;
    }
  }
`

export const Panel = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1200;
  width: 300px;
  max-width: calc(100vw - 16px);
  display: flex;
  flex-direction: column;
  padding: 6px;
  background: #ffffff;
  border: 1px solid ${color.line};
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(9, 9, 11, 0.14), 0 2px 6px rgba(9, 9, 11, 0.06);
  font-family: ${font};
  text-align: left;
  cursor: default;
  animation: ${pop} 0.14s ease;
  transform-origin: top right;
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px 12px;

  .who {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  b {
    font-size: 14.5px;
    font-weight: 700;
    color: ${color.text};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    font-size: 12.5px;
    color: ${color.muted};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 6px 0;
  border-top: 1px solid ${color.line};
`

export const Caption = styled.div`
  padding: 2px 10px 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${color.faint};
`

export const Chip = styled.span`
  flex: none;
  padding: 0 7px;
  border-radius: 999px;
  background: #fde8ef;
  color: #be123c;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 18px;
`

export const TenantCard = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 4px;
  padding: 10px 10px 10px 12px;
  border: 1px solid ${color.line};
  border-radius: 10px;
  background: #fafafa;
  font-family: ${font};
  text-align: left;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease;

  &:hover:not(:disabled) {
    border-color: #d4d4d8;
    background: #ffffff;
  }

  &:disabled {
    cursor: default;
  }

  .name {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: ${color.text};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .swap {
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid ${color.line};
    background: #ffffff;
    color: ${color.soft};
    font-size: 12px;
  }
`

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  min-height: 36px;
  padding: 0 10px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: ${color.soft};
  font-family: ${font};
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;

  & > i:first-child {
    flex: none;
    width: 18px;
    text-align: center;
    font-size: 14px;
    color: ${color.muted};
  }

  .label {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .value {
    flex: none;
    font-size: 12.5px;
    color: ${color.faint};
  }

  .chevron {
    flex: none;
    font-size: 10px;
    color: ${color.faint};
  }

  &:hover:not(:disabled) {
    background: ${color.hover};
    color: ${color.text};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  ${({ selected }) =>
    selected &&
    css`
      background: ${color.active} !important;
      color: ${color.text};
      font-weight: 600;

      svg {
        flex: none;
        color: ${color.accent};
      }
    `}
`

export const Back = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: ${color.text};
  font-family: ${font};
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;

  i {
    font-size: 12px;
    color: ${color.muted};
  }

  &:hover {
    background: ${color.hover};
  }
`

export const Search = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  margin: 4px 4px 6px;
  padding: 0 10px;
  border: 1px solid #e4e4e7;
  border-radius: 9px;
  color: ${color.faint};
  cursor: text;

  &:focus-within {
    border-color: #a1a1aa;
    box-shadow: 0 0 0 3px rgba(161, 161, 170, 0.18);
  }

  input {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    font-family: ${font};
    font-size: 14px;
    color: ${color.text};

    &::placeholder {
      color: ${color.faint};
    }
  }
`

export const TenantList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  max-height: min(340px, calc(100vh - 220px));
  overflow-y: auto;
  padding-bottom: 2px;
  scrollbar-width: thin;
  scrollbar-color: #e4e4e7 transparent;
`

export const Empty = styled.div`
  padding: 14px 10px;
  font-size: 13px;
  color: ${color.muted};
  text-align: center;
`

/** Botão só com ícone (ações do cabeçalho das notificações). */
export const IconAction = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${({ danger }) => (danger ? color.danger : color.muted)};
  font-size: 14px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ danger }) => (danger ? '#fef2f2' : color.hover)};
    color: ${({ danger }) => (danger ? color.danger : color.text)};
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`
